module.exports = __webpack_public_path__ + "fonts/e06f8fa7-aeda-4810-967e-0fd3d4621441.4a40c9a8.ttf";